import { commonUtils } from '@/helpers/commonUtils'
import { BaseVm } from '@/mobxTools'
import { buyVipService } from '@/services/buyVipService'
import { userService } from '@/services/userService'
import { observable } from 'mobx'
import { PayQrDialogProps } from '.'

export class PayQrDialogVm extends BaseVm<PayQrDialogProps> {
  props!: PayQrDialogProps

  @observable visible = false
  @observable currentTabKey: 'wx_pub_qr' | 'alipay_qr' = 'alipay_qr'
  @observable qrUrl?: string
  @observable qrErr = false
  @observable qrLoading = false

  // 折扣价格状态，用于保存使用折扣码后的价格
  @observable discountCodePercent: number | null = null
  @observable discountCodeData: {
    discountCode: string
    statusInfo: {
      status: 'none' | 'success' | 'error'
      msg: string
    }
  } = {
    discountCode: '',
    statusInfo: {
      status: 'none',
      msg: '',
    },
  }
  private timer?: any
  private sessionId?: string
  public onViewDestroy() {
    this.clearTimeout()
  }

  public onPropsChange() {
    if (!this.props.open || !this.props.plan) {
      this.clearTimeout()
      return
    }
    this.genOrderQrCode()
  }

  public async genOrderQrCode() {
    if (!userService.isLogin) {
      console.error('未找到用户登录态')
      return
    }

    const isDiscountCode =
      this.discountCodeData.discountCode !== undefined && this.discountCodeData.discountCode

    // 常规模式：清空二维码状态
    if (!isDiscountCode) {
      this.clearTimeout()
      this.qrErr = false
      this.qrUrl = ''
      this.discountCodePercent = null
    }

    const sessionId = commonUtils.genId()
    this.sessionId = sessionId
    const selectPlan = this.props.plan
    try {
      this.qrLoading = true
      const { qr, orderId, money } = await buyVipService.createOrder({
        action: userService.userData?.versionData.version === 'free' ? 'buy' : 'renew',
        // chargeChannel: this.currentTabKey,
        chargeChannel:
          selectPlan.isSubscription && this.currentTabKey === 'alipay_qr'
            ? 'alipay_agreement_qr'
            : this.currentTabKey,
        planId: selectPlan.id,
        version: selectPlan.version,
        source: this.props.source,
        ...(isDiscountCode && { discountTicket: this.discountCodeData.discountCode }),
      })
      if (this.sessionId !== sessionId) {
        return
      }

      // 折扣码模式：更新成功状态
      if (isDiscountCode) {
        this.discountCodeData = {
          ...this.discountCodeData,
          statusInfo: {
            status: 'success',
            msg: '兑换成功',
          },
        }
        this.clearTimeout()
        // 计算折扣百分比，避免浮点数精度问题

        this.discountCodePercent = Number(money / selectPlan.price)
        // this.discountCodePercent = Number(((money / selectPlan.price) * 100).toFixed(2))

        selectPlan.discountPrice = money / 100
      }

      this.qrUrl = qr

      this.pollingOrderStatus(orderId, true)
    } catch (error) {
      console.log(error)
      // 根据模式选择不同的错误处理
      if (isDiscountCode) {
        // 折扣码模式：更新 statusInfo
        this.discountCodeData = {
          ...this.discountCodeData,
          statusInfo: {
            status: 'error',
            msg: commonUtils.formatErrorMsg(error, '兑换码无效'),
          },
        }
      } else {
        // 常规模式：更新 qrErr
        this.qrErr = true
      }
    } finally {
      this.qrLoading = false
    }
  }

  private async pollingOrderStatus(orderId: string, force = false, cnt = 0) {
    if (!this.props.open) {
      return
    }
    if (force) {
      try {
        const { status } = await buyVipService.pollOrderStatus(orderId)
        if (status === 'completed') {
          try {
            commonUtils.sendExtensionMessage('markPaid', {})
            userService.updateUserInfo()
          } catch (error) {}
          if (this.props.paySuccess) {
            this.props.paySuccess()
          }
          setTimeout(() => {
            if (this.props.onClose) {
              this.props.onClose()
            }
          })
          /** 停止轮询,给出成功提示 */
          this.clearTimeout()
          return
        }
        if (status === 'canceled' || status === 'refunded') {
          /** 停止轮询 */
          return
        }
        if (status === 'created') {
          /** 取消上一次轮询 */
          this.clearTimeout()
          this.timer = setTimeout(() => {
            this.pollingOrderStatus(orderId, true, 0)
          }, 1000)
        }
      } catch (error) {
        if (cnt > 5) {
          this.clearTimeout()
          this.qrErr = true
          /** 重试结束，停止轮询 */
          return
        }
        this.pollingOrderStatus(orderId, true, cnt + 1)
      }
    }
  }

  private clearTimeout() {
    if (this.timer) {
      clearTimeout(this.timer)
    }
  }
}
